import { agreementTemplateInitialStatus as initialStatus } from './agreementTemplateInitialStatus';
import {
  agreementTemplateInitialItem as initialItem,
  agreementTemplateInitialItems as initialItems,
  agreementTemplateInitialValues as initialValues,
} from './agreementTemplateInitialValues';

export default { initialStatus, initialValues, initialItem, initialItems };
